module.exports = __webpack_public_path__ + "img/FIoT.1b90f7f7.jpeg";